<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="创建收货单"
        class="customer-edit"
        width="1000px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="purchase"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="编号">
              <el-input v-model="purchase.no" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="采购组">
              <el-input v-model="purchase.buyUserName" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="采购订单号">
              <el-input v-model="purchase.buyOrderNO" disabled placeholder="请输入" @click.native="$refs.preview.open(purchase.pkid)"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="供应商">
              <el-input v-model="purchase.gysName" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单创建时间">
              <el-input v-model="purchase.requiredArrivalDate" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="联系人">
              <el-input v-model="purchase.linkMan" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电话">
              <el-input v-model="purchase.linkManPhone" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="传真">
              <el-input v-model="purchase.linkManFax" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>

        <div style="border: 1px solid #f5f5f5;margin: 3% auto;padding: 2%;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="要求到货日期">
                <el-date-picker
                    v-model="purchase.plannedArrivalTime"
                    align="right"
                    type="date"
                    placeholder="选择日期"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注">
            <el-input v-model="purchase.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </div>

        <div>
          <el-table
              :data="tableData"
              border
              style="width: 100%">
            <el-table-column
                prop="rowIndex"
                align="center"
                label="序号"/>
            <el-table-column
                prop="sapmaterialNO"
                align="center"
                label="物料编号"/>
            <el-table-column
                prop="sapmaterialName"
                width="180px"
                align="center"
                label="物料名称"/>
            <el-table-column
                prop="requireDeliveryDate"
                width="180px"
                align="center"
                label="采购订单交期"/>
            <el-table-column
                prop="sumQuantity"
                align="center"
                label="采购数量"/>
            <el-table-column
                prop="sendedQuantity"
                align="center"
                label="已送数量"/>
            <el-table-column
                prop="quantity"
                align="center"
                label="送货数量">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.quantity"
                    align="center"
                    type="number"
                    min="1"
                    :max="scope.row.sumQuantity-scope.row.sendedQuantity"/>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>

      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submit">保存</el-button>
      </span>
    </el-dialog>
    <preview ref="preview" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import VmDistrict from "@/components/VmDistrict";
  import constant from "../../../util/constant";
  import Preview from "@/views/purchase/purchaseOrderManager/Preview";

  export default {
    name:"PurchaseOrderManagerEdit",
    components: {Preview},
    coactiveName: "first",mponents: {VmDistrict},
    data() {
      return {
        constant,
        statu:constant.toSelect(constant.purchaseStatus,"addAll"),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData: [],
        activeName: "first",
        purchase: {
          pkid:"",
          no: "",
          purchaseOrderNO: "",
          buyOrderNO: "",
          status: "",
          receiveStatus: "",
          creatorName: "",
          createdTime: "",
          arrivedTime: "",
          gysName: "",
          buyUserName: "",
          linkMan: "",
          linkManFax: "",
          linkManPhone: "",
          requiredArrivalDate: "",
          plannedArrivalTime: "",
          planAddDateBegin: "",
          planAddDateEnd: "",
          autcalDateBegin: "",
          autcalDateEnd: "",
          receiveDetails: [],
        },
        ruleValidate: {
          postName: {required: true, message: "不能为空",trigger: "blur"},
          parentName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.purchase.pkid = id;
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", `sAPPurchaseOrders/createReceiveOrder/${this.purchase.pkid}`)
          .then(resp => {
            this.purchase = resp;
            console.log(resp);
            for(let item of resp.receiveDetails) {
              item.quantity = item.sumQuantity;
            }
            this.tableData = resp.receiveDetails;
            console.log(this.tableData);
          });
      },
      //删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","sAPPurchaseOrders",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      submit() {
        for(let item of this.tableData) {
          if(item.quantity<1 || item.quantity>item.sumQuantity-item.sendedQuantity) {
            this.$message.error("送货数量不能小于1也不能超过采购数量减已送数量");
            return;
          }
        }
        this.purchase.receiveDetails = this.tableData;
        this.handleSubmit();
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          this.submitLoading = true;
          if(valid) {
            this.$http
              .post("basic", "purchaseReceives", this.purchase)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
    .el-form-item__content{
        margin-left: 2%!important;
    }
</style>
